export default {"src":"/_next/static/media/modern-entry-point.d26e97df.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};